import React from "react";
import { DialogContent, Typography } from "@mui/material";
import { Done } from "@mui/icons-material";
import { t } from "i18next";

interface ISupplierContactDataReportSuccessProps {
    ticketNumber: string;
}

export const SupplierContactDataReportSuccess = (props: ISupplierContactDataReportSuccessProps) => {
    return <DialogContent className={"contact-validation-feedback-popup"}>
        <div className={"contact-validation-feedback-popup__icon"}>
            <Done color={"success"} />
        </div>
        <div className={"contact-validation-feedback-popup__details"}>
            <Typography className={"contact-validation-feedback-popup__title"}>
                {props.ticketNumber}
            </Typography>
            <Typography>
                {t("components.supplierValidationPopup.reportCreated")}
            </Typography>
        </div>
    </DialogContent>;

};
